<div class="input-group date" *ngIf="!rangePicker; else rangeBlock">
	<input type="text" class="form-control m-input" [id]="dateId" [readOnly]="model.readonly" [ngModel]="model.date | date: model.format"
	 name="reviewDate" [placeholder]="model.placeholder" (focusout)="onDateChange($event)" [disabled]="model.disabled"
	 autocomplete="off" [required]="model.required" />
	<div class="input-group-append">
		<span class="input-group-text">
			<i class="la la-calendar"></i>
		</span>
	</div>
</div>
<div *ngIf="showErrorMsg" class="red">
	<span *ngIf="model.message; else elseBlock">
		{{model.message}}
	</span>
	<ng-template #elseBlock>
		<span *ngIf="!model.date">Please Select Date</span>
	</ng-template>
</div>

<ng-template #rangeBlock>
	<!-- <div class="input-daterange input-group" [id]="dateId">
		<input type="text" class="form-control m-input" name="start" #startDate [ngModel]="rangePicker.from.date | date: rangePicker.format"
		 (blur)="onDateRangeChange($event, 'start')">
		<div class="input-group-append">
			<span class="input-group-text">
				<i class="la la-ellipsis-h"></i> To
			</span>
		</div>
		<input type="text" class="form-control" name="end" #endDate [ngModel]="rangePicker.to.date | date: rangePicker.format"
		 (blur)="onDateRangeChange($event, 'end')">
	</div> -->
	<div class="input-group date">
		<input type="text" class="form-control m-input" [id]="dateId" [ngModel]="rangePicker.from.date | date: 'dd/MM/yyyy'"
		 name="startDate" [placeholder]="rangePicker.from.placeholder" autocomplete="off" (blur)="onDurationChange($event, 'start')" />
		<div class="input-group-append" style="margin-right: 25px;">
			<span class="input-group-text">
				<i class="la la-calendar"></i>
			</span>
		</div>
		<input type="text" class="form-control m-input" [id]="dateId" [ngModel]="rangePicker.to.date | date: rangePicker.format"
		 name="toDate" [placeholder]="rangePicker.to.placeholder" autocomplete="off" (blur)="onDurationChange($event, 'end')" />
		<div class="input-group-append">
			<span class="input-group-text">
				<i class="la la-calendar"></i>
			</span>
		</div>
	</div>
</ng-template>
